import { Visitor } from "@/graphql/generated/schema";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
export const handleEmployeeExport = async (
  headers: any,
  employee: Visitor[] | any,
  selectedRows: Visitor[],
  label: string,
) => {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Visitors");
  sheet.addRow(headers);

  // ✅ 4. Get the data to export
  const rowsToExport = selectedRows.length > 0 ? selectedRows : employee;

  // ✅ 5. Add visitor data rows
  rowsToExport.forEach((v: any) => {
    const signedIn = v.signedIn
      ? moment(v.signedIn).format("h:mma, MMM D, YYYY")
      : "-";
    const signedOut = v.signedOut
      ? moment(v.signedOut).format("h:mma, MMM D, YYYY")
      : "-";
    const diff = moment.duration(moment(v.signedOut).diff(moment(v.signedIn)));
    const hours = diff.hours();
    const minutes = diff.minutes();

    const duration = hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;

    sheet.addRow([
      v.employee?.firstName + " " + v.employee?.lastName || "-",
      signedIn,
      signedOut,
      duration,
    ]);
  });

  // ✅ 6. Auto-fit column widths
  sheet.columns.forEach((col: any) => {
    let maxLength = 10;
    col.eachCell({ includeEmpty: true }, (cell: any) => {
      const val = cell.value ? cell.value.toString() : "";
      maxLength = Math.max(maxLength, val.length);
    });
    col.width = maxLength + 2;
  });

  // ✅ 7. Generate and download Excel
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer]),
    `${label}_Report_${moment().format("YYYYMMDD_HHmm")}.xlsx`,
  );
};
